import ImageChar1 from '../assets/images/products/chair/chair-1.png';
import ImageChar2 from '../assets/images/products/chair/chair-2.png';
import ImageChar3 from '../assets/images/products/chair/chair-3.png';
import ImageChar4 from '../assets/images/products/chair/chair-4.png';

export const listProducts = [
  {
    id: 1,
    category: 'chair',
    name: 'Sakarias Armchair',
    image: ImageChar1,
    price: 392,
    starRating: 5
  },
  {
    id: 2,
    category: 'chair',
    name: 'Baltsar Chair',
    image: ImageChar3,
    price: 299,
    starRating: 4
  },
  {
    id: 3,
    category: 'chair',
    name: 'Anjay Chair',
    image: ImageChar4,
    price: 519,
    starRating: 5
  },
  {
    id: 4,
    category: 'chair',
    name: 'Nyantuy Chair',
    image: ImageChar2,
    price: 921,
    starRating: 5
  },
  {
    id: 5,
    category: 'chair',
    name: 'Nyantuy Chair',
    image: ImageChar1,
    price: 921,
    starRating: 5
  },
];
